import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { useFlavour } from '../../context/FlavourContext';
import { INGREDIENTS } from '../../data/mock';
import Reveal from '../../components/Reveal';
import { track } from '../../lib/analytics';

export default function Formula() {
  const { flavour } = useFlavour();
  const [sel, setSel] = useState(0);
  const active = INGREDIENTS[sel];

  return (
    <section className="relative py-20 md:py-28 bg-[#080808]">
      <div className="max-w-[1400px] mx-auto px-5">
        <Reveal className="text-center mb-12">
          <p className="font-cond tracking-[0.3em] text-white/40 text-sm mb-3">SCIENCE. NATURE. PERFORMANCE.</p>
          <h2 className="font-display text-4xl md:text-6xl">WHAT'S INSIDE<br /><span className="text-flavour flavour-transition">THE POWER?</span></h2>
          <p className="text-white/50 mt-3">9 active ingredients. One formula. Tap an ingredient to learn more.</p>
        </Reveal>

        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-8 items-center">
          {/* ingredient grid */}
          <div className="grid grid-cols-3 gap-3 order-2 lg:order-1">
            {INGREDIENTS.map((ing, i) => {
              const on = i === sel;
              return (
                <button
                  key={ing.id}
                  onClick={() => { setSel(i); track('ingredient_opened', { ingredient: ing.id }); }}
                  className="relative rounded-xl overflow-hidden border text-left transition-all duration-300"
                  style={{ borderColor: on ? flavour.primary : 'rgba(255,255,255,0.1)', boxShadow: on ? `0 0 30px -8px rgba(${flavour.rgb},0.5)` : 'none' }}
                >
                  <div className="h-16 w-full overflow-hidden">
                    <img src={ing.image} alt={ing.name} loading="lazy" className="w-full h-full object-cover opacity-80" />
                  </div>
                  <div className="p-2 bg-[#0d0d0d]">
                    <p className="font-cond text-xs tracking-wide leading-tight truncate">{ing.name}</p>
                    <p className="text-[10px]" style={{ color: on ? flavour.primary : 'rgba(255,255,255,0.4)' }}>{ing.amount}</p>
                  </div>
                </button>
              );
            })}
          </div>

          {/* featured detail */}
          <div className="order-1 lg:order-2 relative rounded-3xl overflow-hidden border border-white/10 p-8 min-h-[320px] flex flex-col justify-between"
            style={{ background: `radial-gradient(circle at 20% 20%, rgba(${flavour.rgb},0.15), transparent 60%), #0b0b0b` }}>
            <div className="absolute right-0 top-0 w-40 h-40 opacity-30 blur-2xl rounded-full" style={{ background: flavour.primary }} />
            <div>
              <p className="font-cond tracking-[0.25em] text-sm" style={{ color: flavour.primary }}>FEATURED INGREDIENT</p>
              <h3 className="font-display text-4xl md:text-5xl mt-2">{active.name}</h3>
              <p className="font-cond tracking-wide text-white/50 mt-1">{active.tag}</p>
              <p className="text-white/70 mt-4 max-w-md">{active.claim}</p>
            </div>
            <div className="mt-6 flex items-end justify-between">
              <div className="flex flex-col gap-2">
                {['Carefully selected', 'Precise dosage', 'Full transparency'].map((c) => (
                  <span key={c} className="flex items-center gap-2 text-sm text-white/60"><Check className="w-4 h-4" style={{ color: flavour.primary }} /> {c}</span>
                ))}
              </div>
              <div className="text-right">
                <p className="font-display text-4xl" style={{ color: flavour.primary }}>{active.amount}</p>
                <p className="text-xs text-white/40 font-cond tracking-wide">PER SERVING</p>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-xs text-white/30 mt-8 max-w-2xl mx-auto">Health &amp; functional claims are placeholders and fully editable — insert your final legally approved wording via CMS. Not intended to diagnose, treat or cure any condition.</p>
      </div>
    </section>
  );
}
